import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Conversation from '../../conversationDialog/ChildConversationDialog';
import Image from '../../image/SecondaryImage';
import Resources from '../../resourceLinks/ResourceLinks';
import KpiDashboard from '../../kpi/KpiDashboard';//eslint-disable-line import/no-named-as-default
import AudioControls from "../../audio/SimpleAudioController";
import * as trackingDataActions from '../../../../actions/trackingDataActions';
import * as userDataActions from '../../../../actions/userDataActions';
import * as appHelper from '../../../../helpers/appHelper';
import * as dataHelper from '../../../../helpers/dataHelper';
import * as objectConstants from '../../../../constants/objectConstants';
import * as appConstants from '../../../../constants/appConstants';
import * as assetConstants from '../../../../constants/assetConstants';
import * as kpiConstants from '../../../../constants/kpiConstants';
import * as imageHelper from '../../../../helpers/imageHelper';
import * as animationHelper from "../../../../helpers/animationHelper";


class MultipleAnswerFeedbackReview extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            options: this.props.options,
            locale: appHelper.getLocalData(this.props.responseData.outcome),
            showFeedbackContent: false,
            showKpis: appHelper.isDefined(this.props.responseData.outcome.kpis) && this.props.responseData.outcome.kpis !== null && this.props.responseData.outcome.kpis.length > 0,
            showProgression: false,
            kpiDashboardParams: {
                responseReview: true,
                showTitle: false,
                showImmediateImpact: true,
                allowUpdates: false
            },
            hasDialogs: appHelper.isDefined(this.props.responseData.outcome.dialogs) && this.props.responseData.outcome.dialogs.length > 0,
            dialogComplete: !appHelper.isDefined(this.props.responseData.outcome.dialogs) || this.props.responseData.outcome.dialogs.length === 0,
            callbacks: {},
            resourceLinks: [],
            hasResources: false,
            resourcesAreComplete: true,
            hasLeftAsset: appHelper.isDefined(this.props.responseData.outcome.feedback_settings.left) && this.props.responseData.outcome.feedback_settings.left.constant !== assetConstants.ASSET_TYPE_METRIC_RESULT,
            hasRightAsset: appHelper.isDefined(this.props.responseData.outcome.feedback_settings.right) && this.props.responseData.outcome.feedback_settings.right.constant !== assetConstants.ASSET_TYPE_METRIC_RESULT,
            hasTopAsset: appHelper.isDefined(this.props.responseData.outcome.feedback_settings.top) && this.props.responseData.outcome.feedback_settings.top.constant !== assetConstants.ASSET_TYPE_METRIC_RESULT,
            hasBottomAsset: appHelper.isDefined(this.props.responseData.outcome.feedback_settings.bottom) && this.props.responseData.outcome.feedback_settings.bottom.constant !== assetConstants.ASSET_TYPE_METRIC_RESULT,
            imageStyles: {},
            imageClass: "",
            updateImageStyles: false,
            imageStylesSet: false,
            feedbackAsset: {
                src: ""
            },
            feedbackAssetData: {},
            refValue: `${this.props.asset_id}_feedbackWrapper`,
            creditLabel: `${appHelper.getLocaleString("credit_label")}`,
            audio: {
                src: "",
            },
            allowAudioAutoPlay: false,
            showLabels: true,
            showAnimation: false,
        };
        this.show = this.show.bind(this);
        this.showFeedbackContent = this.showFeedbackContent.bind(this);
        this.showKpiDashboard = this.showKpiDashboard.bind(this);
        this.showProgressionButton = this.showProgressionButton.bind(this);
        this.onFeedbackRevealed = this.onFeedbackRevealed.bind(this);
        this.onFeedbackHidden = this.onFeedbackHidden.bind(this);
        this.onProgressionClicked = this.onProgressionClicked.bind(this);
        this.dialogsOnComplete = this.dialogsOnComplete.bind(this);
        this.setCallbacks = this.setCallbacks.bind(this);
        this.onResourcesComplete = this.onResourcesComplete.bind(this);
        this.setResources = this.setResources.bind(this);
        //new
        this.getImagePath = this.getImagePath.bind(this);
        this.setClass = this.setClass.bind(this);
        this.setIconClass = this.setIconClass.bind(this);
        this.getImageStyles = this.getImageStyles.bind(this);
        this.getAssetType = this.getAssetType.bind(this);

        //Create Refs
        this.feedbackPanel = React.createRef();
        this.contentWrapper = React.createRef();
    }

    componentDidMount() {
        this.setCallbacks();
        this.getAssets();
        this.getImageStyles();
        this.setResources();
        this.show();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.props.responseData.outcome),
                creditLabel: `${appHelper.getLocaleString("credit_label")}`,
            });
        }
    }

    componentDidUpdate() {
        if (!this.state.imageStylesSet) {
            this.getImageStyles();
        }
    }


    onFeedbackRevealed() {
        //this.setState({showResponse: true});
        this.showKpiDashboard();
    }

    onFeedbackHidden() {
        this.setState(
            {
                //showResponse: false,
                showFeedbackContent: false,
                showKpis: false,
                showProgression: false
            }
        );
    }

    showFeedbackContent() {
        this.setState({showFeedbackContent: true});
    }

    showKpiDashboard() {
        if (appHelper.isDefined(this.props.responseData.outcome) && appHelper.isDefined(this.props.responseData.outcome.kpis) && this.props.responseData.outcome.kpis !== null && this.props.responseData.outcome.kpis.length > 0) {
            this.setState({showKpis: true});
        } else {
            this.showFeedbackContent();
        }
    }

    showProgressionButton() {
        let selectedOptions = [];
        for (let i = 0; i < this.props.responseData.checkedOptions.length; i++) {
            let selectedOption = this.props.responseData.checkedOptions[i];
            selectedOptions = dataHelper.immutablePush(selectedOptions, selectedOption.option_id);
        }
        this.setState({showProgression: true});
    }

    onProgressionClicked() {
        this.hide();
    }

    show() {
        /*let feedbackPanel = this.feedbackPanel.current;
        let params = {
            ele: feedbackPanel,
            duration: objectConstants.FEEDBACK_DURATION,
            delay: 0,
            callback: this.onFeedbackRevealed
        };
        animationHelper.showHeight(params);*/
    }

    hide() {
        let feedbackPanel = this.feedbackPanel.current;
        let params = {
            ele: feedbackPanel,
            duration: objectConstants.FEEDBACK_DURATION,
            delay: 0,
            callback: this.onFeedbackHidden
        };
        animationHelper.hideHeight(params);
    }

    dialogsOnComplete() {
        this.setState({dialogComplete: true});
    }

    setCallbacks() {

    }

    setResources() {
        let resourceLinks = appHelper.setResourceLinks(this.props.responseData.outcome);

        this.setState({
            resourceLinks: Object.assign([], resourceLinks),
            hasResources: resourceLinks.length > 0
        });

    }

    onResourcesComplete() {
        if (!this.state.resourcesAreComplete) {
            this.setState({resourcesAreComplete: true, checkComplete: true});
        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    getAssets() {

        let feedbackAsset = {};
        let feedbackAssetData = {};

        if (this.state.hasLeftAsset) {
            feedbackAsset = this.getAssetType(this.props.responseData.outcome.feedback_settings.left);
            feedbackAssetData = Object.assign({}, this.props.responseData.outcome.feedback_settings.left);
        } else if (this.state.hasRightAsset) {
            feedbackAsset = this.getAssetType(this.props.responseData.outcome.feedback_settings.right);
            feedbackAssetData = Object.assign({}, this.props.responseData.outcome.feedback_settings.right);
        } else if (this.state.hasTopAsset) {
            feedbackAsset = this.getAssetType(this.props.responseData.outcome.feedback_settings.top);
            feedbackAssetData = Object.assign({}, this.props.responseData.outcome.feedback_settings.top);
        } else if (this.state.hasBottomAsset) {
            feedbackAsset = this.getAssetType(this.props.responseData.outcome.feedback_settings.bottom);
            feedbackAssetData = Object.assign({}, this.props.responseData.outcome.feedback_settings.bottom);
        }


        if (feedbackAssetData.constant === assetConstants.ASSET_TYPE_IMAGE) {
            feedbackAssetData = Object.assign({}, feedbackAssetData, {
                allow_diagram_zoom: this.props.responseData.outcome.feedback_settings.allow_diagram_zoom,
                show_diagram_title: this.props.responseData.outcome.feedback_settings.show_diagram_title,
                show_diagram_description: this.props.responseData.outcome.feedback_settings.show_diagram_description,

            });
        }

        this.setState({
            feedbackAsset: Object.assign({}, feedbackAsset),
            feedbackAssetData: Object.assign({}, feedbackAssetData),
            enableProgression: !appHelper.isDefined(this.state.feedbackAssetData.constant) || this.state.feedbackAssetData.constant !== assetConstants.ASSET_TYPE_METRIC_RESULT ? true : this.state.enableProgression
        });

        if (appHelper.isDefined(this.props.responseData.outcome.assets)) {
            let imageAsset = appHelper.getImageAsset(this.props.responseData.outcome.assets);
            //imageAsset = appHelper.isDefined(imageAsset.locale) ? appHelper.getLocalData(imageAsset) : imageAsset;

            if (appHelper.isDefined(imageAsset) && imageAsset.src.length > 0) {
                this.setState({imageAsset: imageAsset});
            }
        }

        if (appHelper.isDefined(this.props.responseData.outcome.audio) && appHelper.isDefined(this.state.locale.audio)) {
            let audio = appHelper.getAudioAsset(this.state.locale.audio);

            if (appHelper.isDefined(this.props.responseData.outcome.audio.enabled) && this.props.responseData.outcome.audio.enabled) {
                if (appHelper.isDefined(this.props.responseData.outcome.audio.show_audio_controls) && this.props.responseData.outcome.audio.show_audio_controls) {
                    this.setState({
                        audio: Object.assign({}, audio),
                    });
                }/* else {
                    let audioObj = {
                        audioRef: `audio_${audio.id}_${audio.type}`,
                    };
                    if (appHelper.isDefined(this.props.actions.setAudio) && appHelper.isDefined(this.props.responseData.outcome.audio.auto_play) && this.props.responseData.outcome.audio.auto_play) {
                        this.props.actions.setAudio(audioObj);
                    }
                }*/
            }
        }
    }

    getAssetType(asset) {
        let returnAsset = {};
        if (asset.constant === assetConstants.ASSET_TYPE_ICON) {
            returnAsset = appHelper.getIconAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_IMAGE) {
            returnAsset = appHelper.getImageAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_LIBRARY_IMAGE) {
            returnAsset = appHelper.getLibraryImageAsset(asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_ID_CHARACTER) {
            let characterAsset = appHelper.getCharacterAsset(asset);
            returnAsset = appHelper.getCharacterPose(characterAsset, asset);
        } else if (asset.constant === assetConstants.ASSET_TYPE_METRIC_RESULT) {
            returnAsset = Object.assign({}, asset);
        }
        returnAsset = appHelper.isDefined(returnAsset.locale) ? appHelper.getLocalData(returnAsset) : returnAsset;

        if (appHelper.isDefined(asset.constant) && !appHelper.isDefined(returnAsset.type)) {
            returnAsset = Object.assign({}, returnAsset, {
                type: asset.constant
            });
        }

        return returnAsset;
    }

    setClass() {

        let className = "";
        if (appHelper.isDefined(this.props.responseData.outcome.feedback_settings.class_name) && this.props.responseData.outcome.feedback_settings.class_name.length > 0) {
            className += ` ${this.props.responseData.outcome.feedback_settings.class_name}`;
        } else {
            className += "standard-block";
        }

        if (appHelper.isDefined(this.props.responseData.outcome.feedback_settings.bullet_list_style) && this.props.responseData.outcome.feedback_settings.bullet_list_style !== null) {
            className += ` ${this.props.responseData.outcome.feedback_settings.bullet_list_style}`;
        }
        return className;
    }

    setIconClass() {
        let iconClass = '';

        if (this.state.hasLeftAsset) {

            iconClass += 'left-asset ';
        } else if (this.state.hasRightAsset) {
            iconClass += 'right-asset ';
        } else if (this.state.hasTopAsset) {
            iconClass += 'top-asset ';
        } else if (this.state.hasBottomAsset) {
            iconClass += 'bottom-asset ';
        }

        if (this.state.feedbackAssetData.constant === assetConstants.ASSET_TYPE_IMAGE) {
            iconClass += 'image ';
        }
        return iconClass;
    }

    getImageStyles() {

        let refValue = this.contentWrapper.current;
        if (appHelper.isDefined(refValue) && refValue !== null && appHelper.isDefined(this.state.feedbackAsset.src) && this.state.feedbackAsset.src.length > 0) {
            let assetStyles = imageHelper.checkAssetImageWidth(this.props.responseData.outcome.feedback_settings, this.state.feedbackAsset, refValue.offsetWidth).styles;
            this.setState({
                updateImageStyles: false,
                imageStylesSet: true,
                imageStyles: Object.assign({}, assetStyles),
                imageClass: imageHelper.getAssetImageClass(this.props.responseData.outcome.feedback_settings),
            });
        }
    }

    render() {
        return (
            <div className="clear-both">
                {this.state.hasDialogs
                    ?
                    <Conversation asset_id={this.props.asset_id} option_id={this.props.responseData.outcome.option_id}
                                  dialogs={this.props.responseData.outcome.dialogs} callbacks={this.state.callbacks}
                                  onComplete={this.dialogsOnComplete}/>
                    :
                    null
                }
                <div ref={this.feedbackPanel}>
                    <div className={`feedback-panel ${this.props.responseData.outcome.result}`}
                         ref={`${this.props.asset_id}_feedbackPanel`}>

                        <div className="feedback-content-col">
                            {
                                appHelper.isDefined(this.props.responseData.outcome.kpis) && this.props.responseData.outcome.kpis !== null && this.props.responseData.outcome.kpis.length > 0
                                    ?
                                    <KpiDashboard
                                        displayState={kpiConstants.KPI_DISPLAY_STATE_REVIEW_POINTS_AWARDED}
                                        bite_id={this.props.responseData.bite_id}
                                        screen_id={this.props.responseData.screen_id}
                                        object_id={this.props.responseData.asset_id}
                                        option={this.props.responseData.outcome}
                                        responseReview={this.state.kpiDashboardParams.responseReview}
                                        showImmediateImpact={this.state.kpiDashboardParams.showImmediate}
                                        showTitle={this.state.kpiDashboardParams.showTitle}/>
                                    :
                                    null
                            }
                            <div className={`paragraph-content-wrapper ${this.setIconClass()}`}
                                 ref={this.contentWrapper}>
                                {this.state.hasLeftAsset || this.state.hasTopAsset
                                    ?
                                    <div className="asset-column">
                                        {this.state.feedbackAssetData.constant === assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                        &&
                                        <Image screenObject={this.state.feedbackAssetData}
                                               imageClass={this.state.imageClass} imageStyles={this.state.imageStyles}/>

                                        }
                                        {this.state.feedbackAssetData.constant !== assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                        &&
                                        <div className={`asset-image-wrapper ${this.state.imageClass}`}
                                             style={this.state.imageStyles}>
                                            <img src={this.getImagePath(this.state.feedbackAsset.src)} alt=""/>
                                        </div>
                                        }

                                        {appHelper.isDefined(this.state.feedbackAsset.credit) && this.state.feedbackAsset.credit.length > 0 &&
                                        <div className={`image-credit`}
                                             style={this.state.imageStyles}>{this.state.creditLabel}: {this.state.feedbackAsset.credit}</div>
                                        }

                                    </div>
                                    :
                                    null
                                }
                                <div className="content-column">
                                    {appHelper.isDefined(this.state.locale.feedback) && this.state.dialogComplete
                                        ? <div dangerouslySetInnerHTML={{__html: this.state.locale.feedback}}/>
                                        : null
                                    }
                                    {
                                        appHelper.isDefined(this.props.responseData.outcome.audio) && appHelper.isDefined(this.props.responseData.outcome.audio.show_audio_controls) && this.props.responseData.outcome.audio.show_audio_controls && appHelper.isDefined(this.state.audio.id)
                                            ?
                                            <AudioControls audio={this.state.audio}
                                                           autoPlay={this.state.allowAudioAutoPlay}
                                                           showLabels={this.state.showLabels}
                                                           showAnimation={this.state.showAnimation}
                                                           audioRef={`text_audio_${this.props.responseData.outcome.asset_id}_${this.state.audio.id}_${this.state.audio.constant}`}/>
                                            :
                                            null
                                    }
                                    {
                                        this.state.hasResources
                                            ?
                                            <Resources resources={this.state.resourceLinks}
                                                       onResourcesComplete={this.onResourcesComplete}/>
                                            :
                                            null
                                    }
                                </div>
                                {this.state.hasRightAsset || this.state.hasBottomAsset
                                    ?
                                    <div className="asset-column">
                                        {this.state.feedbackAssetData.constant === assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                        &&
                                        <Image screenObject={this.state.feedbackAssetData}
                                               imageClass={this.state.imageClass} imageStyles={this.state.imageStyles}/>
                                        }
                                        {this.state.feedbackAssetData.constant !== assetConstants.ASSET_TYPE_IMAGE && this.state.imageStylesSet
                                        &&
                                        <div className={`asset-image-wrapper ${this.state.imageClass}`}
                                             style={this.state.imageStyles}>
                                            <img src={this.getImagePath(this.state.feedbackAsset.src)} alt=""/>


                                        </div>
                                        }
                                        {appHelper.isDefined(this.state.feedbackAsset.credit) && this.state.feedbackAsset.credit.length > 0 &&
                                        <div className={`image-credit`}
                                             style={this.state.imageStyles}>{this.state.creditLabel}: {this.state.feedbackAsset.credit}</div>
                                        }


                                    </div>
                                    :
                                    null
                                }
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MultipleAnswerFeedbackReview.propTypes = {
    options: PropTypes.array.isRequired,
    key_messages: PropTypes.array,
    responseData: PropTypes.object.isRequired,
    asset_id: PropTypes.number.isRequired,
    lang: PropTypes.string.isRequired,
    actions: PropTypes.object
};

MultipleAnswerFeedbackReview.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state) {
    let lang = state.userData.lang;
    return {
        lang: lang,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, userDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(MultipleAnswerFeedbackReview);



/** WEBPACK FOOTER **
 ** ./src/components/objects/multipleChoice/multipleAnswer/MultipleAnswerFeedbackReview.js
 **/